import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Tooltip from "@mui/material/Tooltip"
import { MONO } from "../constants"

export function ReactionBar({ reactions, me, onToggle }) {
  if (!reactions || !reactions.length) return null
  const grouped = {}
  for (const r of reactions) {
    (grouped[r.emoji] ??= []).push(r.username)
  }
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.4, mt: 0.3 }}>
      {Object.entries(grouped).map(([emoji, users]) => {
        const mine = users.includes(me)
        return (
          <Tooltip key={emoji} title={users.join(", ")} arrow placement="top">
            <Box onClick={() => onToggle(emoji)}
              sx={{
                display: "flex", alignItems: "center", gap: 0.3, px: 0.6, py: 0.1,
                borderRadius: "10px", cursor: "pointer",
                backgroundColor: mine ? "rgba(245,158,11,0.18)" : "rgba(var(--app-fg-rgb),0.06)",
                border: "1px solid " + (mine ? "rgba(245,158,11,0.4)" : "rgba(var(--app-fg-rgb),0.08)"),
                "&:hover": { borderColor: "rgba(245,158,11,0.35)" },
              }}>
              <span style={{ fontSize: "0.75rem" }}>{emoji}</span>
              <Typography component="span" sx={{ fontFamily: MONO, fontSize: "0.6rem", color: "rgba(var(--app-fg-rgb),0.6)" }}>
                {users.length}
              </Typography>
            </Box>
          </Tooltip>
        )
      })}
    </Box>
  )
}
